/**
 * Retour « sûr » — UN seul comportement pour tous les boutons retour (29/09/2026).
 *
 * `navigate(-1)` ne mène nulle part quand la page est la PREMIÈRE ouverte dans
 * l'application : lien d'e-mail, notification push, QR, partage. Dans l'app
 * (Capacitor), il peut même faire sortir de l'application. React Router 7
 * numérote les entrées de l'historique dans `window.history.state.idx` (0 pour
 * la première page, posé au démarrage par replaceState) : si rien ne précède,
 * on va vers une destination Gively garantie (`repli`), en REMPLAÇANT l'entrée
 * pour ne pas créer de boucle avec le retour du navigateur.
 *
 * Même intention que `useSortieDuTunnel` (tunnel de publication).
 */
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function peutReculer() {
  try {
    return Number(window.history.state?.idx) > 0;
  } catch {
    return false;
  }
}

export function retourSur(navigate, repli = "/") {
  if (peutReculer()) navigate(-1);
  else navigate(repli, { replace: true });
}

export default function useRetour(repli = "/") {
  const navigate = useNavigate();
  return useCallback(() => retourSur(navigate, repli), [navigate, repli]);
}
